import React from 'react';
import { Container, Typography, Button, Grid, Divider } from '@material-ui/core';
import CartItem from './CartItem/CartItem'
import useStyles from './style'
import { Link } from 'react-router-dom'
import Progress from '../MySpinner2/MySpinner';
import clsx from 'clsx'

const Cart = ({ cart, emptyCart, incDecRemove, loading }) => {
    const classes = useStyles();
    const isEmpty = !cart.total_items;

    // console.log({ cart });

    // console.log(isEmpty);
    const EmptyCart = () => (
        <Typography variant="subtitle1">You have no items in your shopping cart, <Link to="/" className={classes.link}>start adding some</Link>!</Typography>
    );

    const FilledCart = () => (
        <>
            <Grid container spacing={3}>
                {
                    cart.line_items.map(item => (
                        <Grid item xs={12} sm={6} md={4} key={item.id}>
                            <CartItem item={item} incDecRemove={incDecRemove} />
                        </Grid>
                    ))
                }
            </Grid>

            <Grid container className={classes.cardDetails} spacing={3}>
                <Grid item xs={12} md={6}>
                    <Typography className={classes.subTotal} variant="h4">
                        Subtotal: &nbsp;  <span className={classes.span}>{cart.subtotal.formatted_with_symbol}</span>
                    </Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                    <div className={classes.ButtonsContainer}>
                        <Button className={classes.Button} size="large" type="button" variant="contained" color="secondary" onClick={emptyCart}>
                            Empty The Cart
                        </Button>
                        <Button component={Link} to="/checkout" className={clsx(classes.Button, classes.checkoutButton)} size="large" type="button" variant="contained" color="primary">
                            Check Out
                        </Button>
                    </div>
                </Grid>
            </Grid>
        </>
    )

    return (
        <Container className={classes.container}>
            <div className={classes.toolbar} />
            <Divider style={{ marginTop: '20px' }} />
            <Typography className={classes.title} variant="h3" gutterBottom>Your Shopping Cart</Typography>
            <Divider style={{ marginBottom: '20px' }} />
            {
                loading ? (
                    <Progress />
                ) : isEmpty ? (
                    <EmptyCart />
                ) : (
                    <FilledCart />
                )
            }
        </Container>
    )
}

export default Cart
